import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing(2),
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    border: "3px solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 40,
    },
  },
  texts: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
  },
  title: {
    fontFamily: "'Nunito Sans', 'Avenir Next', 'Segoe UI', sans-serif",
    fontSize: "1.65rem",
    fontWeight: 800,
    lineHeight: 1.32,
    letterSpacing: "-0.012em",
    margin: 0,
    "&.MuiTypography-root": {
      fontWeight: 700,
    },
  },
  description: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "#5B5D66",
    lineHeight: 1.3,
    margin: 0,
  },
  success: {
    backgroundColor: "#E9FBF0",
    borderColor: "#2BE65E",
    color: "#0B7A3B",
  },
  successTitle: {
    color: "#0B7A3B",
  },
  error: {
    backgroundColor: "#FEECEC",
    borderColor: "#E5484D",
    color: "#B42318",
  },
  errorTitle: {
    color: "#B42318",
  },
  warning: {
    backgroundColor: "#FFF6E0",
    borderColor: "#E5A100",
    color: "#7A5300",
  },
  warningTitle: {
    color: "#7A5300",
  },
}));

export default useStyles;
